import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-user-star-line', title: 'VIP Kurye Hizmeti', desc: 'On-Board Courier hizmetimiz uzman personeli, kritik ve yüksek değerli olan gönderileriniz için tam destek sağlar.' },
  { icon: 'ri-flight-takeoff-line', title: 'Kapıdan Kapıya', desc: 'Yükünüzü tam olarak kapınızdan alarak, uçağa biner ve varış noktasına kadar taşımak için gerekli olan tüm çalışmaları yürütürüz.' },
  { icon: 'ri-shield-check-line', title: 'Tam Güvenlik', desc: 'Gönderiniz teslim alındığı andan itibaren sürekli gözetim altında taşınır.' },
  { icon: 'ri-timer-flash-line', title: 'Hızlı Teslimat', desc: 'Kritik gönderileriniz için en hızlı teslimat seçenekleri sunuyoruz.' },
  { icon: 'ri-24-hours-line', title: '7/24 Hizmet', desc: 'Haftanın 7 günü, günün 24 saati On Board Kurye hizmetimizden yararlanabilirsiniz.' },
  { icon: 'ri-global-line', title: 'Dünya Geneli', desc: 'Dünyanın her noktasına On Board Kurye hizmetimizle ulaşabilirsiniz.' },
];

const useCases = [
  { icon: 'ri-medicine-bottle-line', title: 'Tıbbi Malzeme', desc: 'Acil tıbbi ekipman ve ilaç teslimatları.' },
  { icon: 'ri-cpu-line', title: 'Elektronik Parça', desc: 'Kritik üretim hattı için acil parça teslimatı.' },
  { icon: 'ri-vip-diamond-line', title: 'Değerli Eşya', desc: 'Mücevher, sanat eseri ve yüksek değerli ürünler.' },
  { icon: 'ri-file-text-line', title: 'Kritik Belgeler', desc: 'Hukuki ve ticari acil belge teslimatları.' },
];

export default function OnBoardKuryePage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20business%20courier%20walking%20through%20airport%20terminal%20with%20important%20briefcase%2C%20motion%20blur%20background%20of%20busy%20airport%2C%20dramatic%20lighting%20with%20orange%20and%20dark%20tones%2C%20VIP%20courier%20service%20concept%2C%20cinematic%20photography%2C%20determined%20professional%20expression&width=1920&height=680&seq=onboard-hero-01&orientation=landscape"
            alt="On Board Kurye"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(8,10,20,0.92) 0%, rgba(12,18,38,0.80) 55%, rgba(8,10,20,0.50) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 right-20 w-80 h-80 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(120px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>On Board Kurye Servisi</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-user-star-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>On Board Kurye Servisi</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Kritik Gönderiler İçin<br />
                <span style={{ color: 'var(--orange)' }}>On Board Kurye</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                Uzman personelimiz kritik ve yüksek değerli gönderilerinizi kapınızdan alır, uçağa biner ve varış noktasına kadar sürekli gözetim altında taşır. 7/24 VIP kurye hizmeti.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[{ val: 'VIP', lbl: 'Hizmet' }, { val: '7/24', lbl: 'Erişim' }, { val: 'Kapıdan', lbl: 'Kapıya' }, { val: '100%', lbl: 'Güvenlik' }].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Use cases */}
      <section className="py-16" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <h2 className="text-2xl font-bold mb-2" style={{ color: 'var(--text1)' }}>Hangi Gönderiler İçin?</h2>
            <p className="text-sm" style={{ color: 'var(--text3)' }}>On Board Kurye hizmetimiz bu tür kritik gönderiler için idealdir.</p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {useCases.map((u, i) => (
              <div key={i} className="p-6 rounded-2xl text-center" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${u.icon} text-2xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{u.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{u.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features + Image */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-16">
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[280px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=courier%20handing%20over%20important%20package%20at%20airport%20gate%2C%20professional%20handover%20of%20critical%20shipment%2C%20airport%20terminal%20background%2C%20warm%20professional%20lighting%2C%20trust%20and%20security%20concept%2C%20business%20logistics%20photography&width=420&height=280&seq=onboard-content-01&orientation=landscape"
                alt="On Board Kurye teslimat"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Hizmet Hakkında</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                On-Board Courier hizmetimiz uzman personeli, kritik ve yüksek değerli olan gönderileriniz için tam destek sağlar. Yükünüzü tam olarak kapınızdan alarak, uçağa biner ve varış noktasına kadar taşımak için gerekli olan tüm çalışmaları yürütürüz.
              </p>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                Gönderiniz teslim alındığı andan itibaren sürekli gözetim altında taşınır. Haftanın 7 günü, günün 24 saati hizmetinizdeyiz.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>On Board Kurye İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Kritik gönderileriniz için uzman ekibimiz hazır.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
